import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiService {

    // Api utilities:
    public responseValid(response: any): boolean {
        if (response && (response == true || (response.ErrorCode == 0 && response.Result))) {
            return true;
        }
        return false;
    }
}
